import * as Yup from 'yup';

// camelCase keys: the backend deep-underscores incoming params
// (rMin -> r_min), and mirrors ReactorEconomyConfig#sane_bounds:
// 0 < r_min <= r_max, and d_cap > 1 (so ln(d_cap) > 0 in rate()).
export const reactorEconomyConfigSchema = Yup.object({
  rMin: Yup.number()
    .typeError('R_MIN debe ser un número')
    .moreThan(0, 'R_MIN debe ser mayor a 0')
    .required('R_MIN es obligatorio'),
  rMax: Yup.number()
    .typeError('R_MAX debe ser un número')
    .required('R_MAX es obligatorio')
    .min(Yup.ref('rMin'), 'R_MAX debe ser mayor o igual a R_MIN'),
  dCap: Yup.number()
    .typeError('D_CAP debe ser un número')
    .moreThan(1, 'D_CAP debe ser mayor a 1')
    .required('D_CAP es obligatorio'),
  // Entero a propósito: los créditos se gastan de a unidades enteras, así que un
  // 30,5 se vería como 30 y solo genera confusión.
  welcomeAmount: Yup.number()
    .typeError('El bono debe ser un número')
    .min(0, 'El bono no puede ser negativo')
    .integer('El bono debe ser un número entero')
    .required('El bono de bienvenida es obligatorio'),
});

export type ReactorEconomyConfigFormData = {
  rMin: number;
  rMax: number;
  dCap: number;
  welcomeAmount: number;
};
